<template>
  <div class="logout-page"></div>
</template>

<script>
  export default {
    name: 'LogoutPage',
    mounted () {
      if (!this.$modal) {
        this.$nextTick(() => {
          this.logout()
        })
      } else {
        this.logout()
      }
    },
    methods: {
      logout () {
        this.$modal.show({
          title: 'ยืนยันออกจากระบบ',
          text: 'หากคุณออกจากระบบ ข้อมูลการบริจาคที่คงค้างจะถูกลบ ต้องการออกจากระบบหรือไม่?',
          okButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          cancelButton: true,
          ok: () => {
            this.$store.dispatch('logout', true).then(() => {
              this.$router.push('/user/login')
            })
          },
          cancel: () => {
            this.$router.back()
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LogoutPage.vue?2e6e96ee